module.exports = __webpack_public_path__ + "img/1f286e1cecb7a006cde64fadb6d6e8b7.svg";